module.exports = __webpack_public_path__ + "static/media/python.598a630d.jpg";